import BenchlingConfig from 'BenchlingConfig';

/**
 * Whether the Agents (routines) UI should be available. Requires Chat, the tenant Agents gate, and
 * at least one routine trigger type until triggerless agents are supported (BNCH-177543). Gate
 * Agents entry points (sidebar nav, settings tabs) on this so we do not surface flows users cannot
 * complete.
 */
export function isAgentsFeatureEnabled(): boolean {
  return (
    BenchlingConfig.LLM_ENABLE_ASSISTANT_AGENT &&
    BenchlingConfig.LLM_ENABLE_AGENTS &&
    // TODO(BNCH-177543): Remove once triggerless agents are supported.
    (BenchlingConfig.LLM_ENABLE_ROUTINES_TIME_BASED || BenchlingConfig.LLM_ENABLE_ROUTINES_EVENT_BASED)
  );
}

/**
 * Whether agents that run on a schedule are available. The two trigger types are configured
 * independently (event-based is off by default and unavailable on GxP tenants), so anything that
 * commits the user to one specific trigger type must check that type rather than
 * {@link isAgentsFeatureEnabled}, which is satisfied by either.
 */
export function isTimeBasedAgentsEnabled(): boolean {
  return BenchlingConfig.LLM_ENABLE_ASSISTANT_AGENT && BenchlingConfig.LLM_ENABLE_ROUTINES_TIME_BASED;
}

/** Whether agents that run in response to an event are available. See {@link isTimeBasedAgentsEnabled}. */
export function isEventBasedAgentsEnabled(): boolean {
  return BenchlingConfig.LLM_ENABLE_ASSISTANT_AGENT && BenchlingConfig.LLM_ENABLE_ROUTINES_EVENT_BASED;
}
